/** Angular's `RuntimeErrorCode.DEFER_LOADING_FAILED`, reported as `NG0750`. */
const deferLoadingFailedCode = -750;

/**
 * Whether `error` is a failed dynamic `import()`. Each engine words it
 * differently: Chromium "Failed to fetch dynamically imported module", Firefox
 * "error loading dynamically imported module", Safari "Importing a module
 * script failed".
 */
export function isMissingChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return /dynamically imported module|Importing a module script failed/i.test(
    message,
  );
}

/**
 * Whether `error` is Angular's report that a `@defer` block's dependencies
 * failed to load. In production it carries no cause, only the code.
 */
export function isDeferLoadingFailedError(error: unknown): boolean {
  return (
    error instanceof Error &&
    'code' in error &&
    error.code === deferLoadingFailedCode
  );
}
